export default "__VITE_ASSET__8f470ce2__"